import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useSyncCartItemValuesToForm } from '../../../../fp-b2b-shared/hooks/use-sync-cart-item-values-to-form'
import { CartList } from '../CartList/CartList'
import { CartListItemController } from '../CartListItem/CartListItemController'
import { useCart } from '../CartProvider/CartProvider'

export const CartListItems = () => {
  const { campaignId, projectCode, countryCode, campaignCodeFromUrl, platform } = useCart()
  const { items: cartItems } = useFpB2bCartService(campaignId, platform)
  useSyncCartItemValuesToForm({ campaignId, projectCode, countryCode, campaignCode: campaignCodeFromUrl, platform })

  return (
    <CartList>
      {cartItems?.map((item, index) => (
        <CartListItemController key={item.cartItemId} item={item} index={index} />
      ))}
    </CartList>
  )
}
